import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { GridDetails, GridEvent } from '../../../tracking-overview/interfaces/grid';
import { UrlBuilder } from '../../../../core';

@Component({
    selector: 'scheduled-report-grid',
    template: require('./../common-report-grid.html'),
    styles: [require('./scheduled-report-grid.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScheduledReportGridComponent {

    public pagePerItems = [25, 50, 75, 100, 250, 500];

    @Input()
    public gridDetails: GridDetails;

    @Input()
    public isLoadingCompleted: boolean;

    @Input()
    public showPagination: boolean;

    @Input()
    public showSearchOrFilter: boolean;

    @Input()
    public paginationPagePerItems = [25, 50, 75, 100, 250, 500];

    @Input()
    public initialPageSize = 25;

    @Input()
    public showActionsHeader: boolean;

    @Input()
    public rowLimit: number;

    @Output()
    public onItemClick: EventEmitter<GridEvent> = new EventEmitter<GridEvent>();

    @Output()
    public reloadUpdatedData: EventEmitter<boolean> = new EventEmitter<false>();

    @Output()
    public reloadGeneratedData: EventEmitter<boolean> = new EventEmitter<false>();

    constructor(private urlBuilder: UrlBuilder) { }

    public onGridItemClick(event: GridEvent) {
        //    this.onItemClick.emit(reportId);

        this.urlBuilder.esa().sampletracking().
            report().NewGenerateReport(0).
            navigate({ queryParams: { reportId: event.data.id } });
    }

    public onReloadGridData($event: boolean, isGeneratedGridReload: boolean) {
        if (isGeneratedGridReload) {
            this.reloadGeneratedData.emit($event);
        } else {
            this.reloadUpdatedData.emit($event);
        }
    }

    public onRowSelected($event: any) {
    }
}